<template>
  <v-dialog v-model="show" max-width="500px" persistent>
    <div class="providers__staff_document_modal">
      <span class="providers__staff_document_modal--close_btn" @click="$emit('close-modal')">Cerrar</span>

      <div>
        <span :title="info.document_type">Tipo de documento: {{ info.document_type }}</span>
      </div>

      <div>
        <span v-if="info.expiration_date != null">
          Fecha vencimiento: {{ info.expiration_date | moment("DD MMMM YYYY") }}
        </span>
        <span style="color: red; opacity: 0.7;" v-else>Sin fecha de vencimiento establecida</span>
      </div>

      <div>
        <a
          :href="info.support_file.url"
          target="_blank"
          v-if="info.support_file.url != null">
          Ver soporte
        </a>
        <span style="color: red; opacity: 0.7;" v-else>Sin soporte cargado</span>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: ['info', 'show']
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/providers/document_modals/ViewDocumentModal.vue